import VueIsVisible from './vue-is-visible'

export default VueIsVisible
